module.exports = __webpack_public_path__ + "img/educacao.40f3b18c.svg";